import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import styles from "./your-profile-menu.module.css";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
var ProfilePageLink = function(param) {
    var icon = param.icon, title = param.title, link = param.link, number = param.number;
    var trackEvent = useAnalytics().trackEvent;
    var handleMenuItemClick = function() {
        var menuItemSelectEvent = {
            eventName: "Click Profile Mobile Menu Item",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    category: "my profile menu",
                    action: title.toLowerCase(),
                    label: "tab selection"
                }
            }
        };
        trackEvent(menuItemSelectEvent);
    };
    return /*#__PURE__*/ _jsx("a", {
        href: link,
        onClick: handleMenuItemClick,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.profilePageLinkContainer,
            children: [
                /*#__PURE__*/ _jsx(SvgIcon, {
                    color: "pureBlack",
                    name: icon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.profilePageLinkTitle,
                    children: title
                }),
                !!number && /*#__PURE__*/ _jsx("span", {
                    className: styles.circle,
                    children: number
                })
            ]
        })
    });
};
export var YourProfileMenu = function(param) {
    var favouritesCount = param.favouritesCount;
    return /*#__PURE__*/ _jsxs("nav", {
        className: styles.yourProfileContainer,
        children: [
            /*#__PURE__*/ _jsx(ProfilePageLink, {
                title: "Your cars",
                link: "/my-profile",
                icon: "vehicle-side"
            }),
            /*#__PURE__*/ _jsx(ProfilePageLink, {
                title: "Your part-ex quotes",
                link: "/my-profile/part-exchange",
                icon: "cash"
            }),
            /*#__PURE__*/ _jsx(ProfilePageLink, {
                title: "Favourites",
                link: "/my-profile/favourites",
                icon: "heart-outline",
                number: favouritesCount
            }),
            /*#__PURE__*/ _jsx(ProfilePageLink, {
                title: "Settings",
                link: "/my-profile/settings",
                icon: "settings"
            }),
            /*#__PURE__*/ _jsx(ProfilePageLink, {
                title: "Marketing preferences",
                link: "/my-profile/marketing-preferences",
                icon: "mail"
            })
        ]
    });
};
